import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChanges: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Policy Changes',
        defaultMessage: 'Policy Changes',
    },
    policyChangeEffectiveDate: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date',
    },
    typeOfChange: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Select Type of Changes',
        defaultMessage: 'Select Type of Changes',
    },
    address: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Address',
        defaultMessage: 'Address',
    },
    vehicle: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Vehicle',
        defaultMessage: 'Vehicles',
    },
    driverAssignment: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Driver Assignment',
        defaultMessage: 'Driver Assignment',
    },
    drivers: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Driver',
        defaultMessage: 'Drivers',
    },
    coverages: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Coverages',
        defaultMessage: 'Coverages',
    },
    riskAnalysis: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Risk Analysis',
        defaultMessage: 'Risk Analysis',
    },
    baPolicyChangeTitle: {
        id: 'endorsement.directives.templates.bank-account-details-quote.Policy Change - Auto',
        defaultMessage: 'Policy Change - Auto ({quoteNumber})'
    },
    baPolicyDetails: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Policy Details',
        defaultMessage: 'Policy Details',
    },
    baMailingAddress: {
        id: "endorsement.ba.directives.templates.ba-whats-next.Mailing Address",
        defaultMessage: "Mailing Address"
    },
    baLimit:   {
        id: "endorsement.ba.directives.templates.ba-whats-next.Limit",
        defaultMessage: "Limit/Deductible"
    },
    baInsured:   {
        id: "endorsement.ba.directives.templates.ba-whats-next.Insured",
        defaultMessage: "Named Insured(s) or Additional Named Insured(s)"
    },
    baLienHolder:   {
        id: "endorsement.ba.directives.templates.ba-whats-next.Lienholder/Lessor(s)",
        defaultMessage: "Lienholder/Lessor(s)"
    },
    baGaragedAddress: {
        id: "endorsement.ba.directives.templates.ba-whats-next.Garaged Address",
        defaultMessage: "Garaged Address"
    },
    baPolicyQuote: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Quote',
        defaultMessage: 'Quote',
    },
    baPolicyPayment: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Payments',
        defaultMessage: 'Payments',
    },
    baVehicles: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Vehicles',
        defaultMessage: 'Vehicle(s)',
    },
    baDrivers: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Drives',
        defaultMessage: 'Driver(s)',
    },
    other: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Other',
        defaultMessage: 'Other',
    },
    description: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Description',
        defaultMessage: 'Description',
    }
});
